import { useEffect, useState } from './'

type UsePropChange = <T>(prop: T, callback: () => void) => void

const usePropChange: UsePropChange = (prop, callback) => {
  const [isAlreadyRendered, setIsAlreadyRendered] = useState(false)

  useEffect(() => {
    if (!isAlreadyRendered) {
      setIsAlreadyRendered(true)
    } else {
      callback()
    }
    /* eslint-disable-next-line */
  }, [prop])
}

export default usePropChange
